import { useMemo, useState } from "react"
import { MediaContent } from "trunx"

import { SelectionsResponse } from "modules/ClientAccount/utils"
import style from "modules/ClientAccount/components/Selections/style.module.scss"
import { ItemWithPagination } from "modules/ClientAccount/components/Selections/components/ItemWithPagination"
import { Box, Text, Media, Button } from "ui-kit/components-branded/index"

interface SelectionsProps {
    items: SelectionsResponse[]
}

export const MAX_COUNT_ITEMS = 4

export const Selections = ({ items }: SelectionsProps) => {
    const [maxCountItems, setMaxCountItems] = useState(MAX_COUNT_ITEMS)

    const itemsWithPagination = useMemo(
        () => items.filter((i, index) => index < maxCountItems),
        [items, maxCountItems]
    )

    const handleClickButton = () => {
        setMaxCountItems(maxCountItems + MAX_COUNT_ITEMS)
    }

    return (
        <>
            <div className={style.container}>
                <Box>
                    <Media>
                        <MediaContent>
                            <div className={style.list}>
                                {itemsWithPagination.map((item) => (
                                    <ItemWithPagination item={item} key={item.id} />
                                ))}
                            </div>
                        </MediaContent>
                    </Media>
                </Box>
                {items.length > maxCountItems && (
                    <Button className={style.button} onClick={handleClickButton} secondary>
                        <Text weight="medium">Показать еще</Text>
                    </Button>
                )}
            </div>
        </>
    )
}
